export const baseRoutes = [
    {
        path: '/404',
        component: () => import('@/views/error/404.vue'),
        meta: {
            title: '404',
        },
        hidden: true,
    },

    {
        path: '/',
        name: 'Layput',
        meta: {
            title: '',
        },
        redirect: { path: '/' },
        component: () => import('@/layout/index.vue'),
        children: [
            {
                path: '/',
                name: '首页',
                meta: {
                    title: '健康管理中心_心脏安全检测解决方案_美林医疗官方网站',
                    metas:[
                        {name:'keywords',content:'美林医疗官方网站,美林医疗,健康管理中心,心脏安全检测解决方案'},
                        {name:'description',content:'欢迎访问美林医疗官方网站,健康管理中心让先进的动态心电监测技术广泛应用于临床,提供心脏康复整体解决方案,心脏安全检测解决方案等,致力于为患者带来全方位的心脏健康呵护!'},
                    ]
                },
                component: () => import('@/views/Home/index.vue'),
            },
            {
                path: '/login',
                component: () => import('@/views/login/index.vue'),
                meta: {
                    title: '',
                    hidden: true,
                },
            },
            {
                path: '/user',
                name: 'User',
                meta: {
                    title: '心脏安全行动家_基层六分钟步行试验_美林汇药房有限公司',
                    metas:[
                        {name:'keywords',content:'心脏安全行动家,基层六分钟步行试验,六分钟步行试验,美林汇药房有限公司'},
                        {name:'description',content:'欢迎访问美林汇药房有限公司,美林医疗心脏安全行动家,将继续以科技为先导,以患者为中心,通过基层六分钟步行试验等了解实际情况,不断突破医疗健康领域的边界,为全球心脏健康事业注入源源不断的动力!'}
                    ]
                },
                component: () => import('@/views/User/index.vue'),
            },
            {
                path: '/product',
                name: 'Product',
                meta: {
                    title: '心电图自动诊断机器人_心肺康复管理系统_美林智慧',
                    metas:[
                        {name:'keywords',content:'心电图自动诊断机器人,美林智慧,心肺康复管理系统'},
                        {name:'description',content:'欢迎访问美林智慧,公司产品心电图自动诊断机器人,心肺康复管理系统等,覆盖心脏无创诊断与康复设备,监护设备,急救和睡眠呼吸障碍诊断及治疗设备等!'}
                        ]
                },
                component: () => import('@/views/Product/index.vue'),
            },
            {
                path: '/productDetails/:id',
                name: 'ProductDetails',
                meta: {
                    title: '产品详情',
                },
                component: () => import('@/views/ProductDetails/index.vue'),
            },
            {
                path: '/industryNews',
                name: 'IndustryNews',
                meta: {
                    title: '新闻资讯',
                },
                component: () => import('@/views/IndustryNews/index.vue'),
            },
            {
                path: '/industryNewsDetail/:id',
                name: 'IndustryNewsDetail',
                meta: {
                    title: '资讯详情',
                },
                component: () => import('@/views/IndustryNewsDetail/index.vue'),
            },
            {
                path: '/about/:type',
                name: 'About',
                meta: {
                    title: '心肺康复设备生产厂家_心脏预防评估中心_深圳市美林医疗科技有限公司',
                    metas:[
                        {name:'keywords',content:'心肺康复设备生产厂家,心脏预防评估中心,深圳市美林医疗科技有限公司'},
                        {name:'description',content:'欢迎访问深圳市美林医疗科技有限公司,作为心肺康复设备生产厂家,心脏预防评估中心,全力引入全球先进的无创心脏诊断与康复技术及设备,为推动中国医疗健康事业的进步贡献力量!'}
                        ]
                },
                component: () => import('@/views/About/index.vue'),
            },
            {
                path: '/service',
                name: 'Service',
                meta: {
                    title: '心脏专科体检_心脏预防评估系统_美林心肺康复中心',
                    metas:[
                        {name:'keywords',content:'心脏专科体检,心脏预防评估系统,美林心肺康复中心'},
                        {name:'description',content:'欢迎访问美林心肺康复中心,我们将时尚医疗观念融入产品设计,让心脏预防评估系统等多类相关产品不仅性能卓越,让用户做心脏专科体检等相关检测更充满人文关怀与时尚气息!'}
                    ]
                },
                component: () => import('@/views/Service/index.vue'),
            },
            {
                path: '/talentRecruitment',
                name: 'TalentRecruitment',
                meta: {
                    title: '人才招聘',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/TalentRecruitment/index.vue'),
            },
            {
                path: '/solution',
                name: 'Solution',
                meta: {
                    title: '心脏预防评估中心解决方案_居家康复解决方案_美林医疗心脏康复服务商',
                    metas:[
                        {name:'keywords',content:'心脏预防评估中心解决方案,心脏预防解决方案,居家康复解决方案,美林医疗心脏康复服务商'},
                        {name:'description',content:'美林医疗心脏康复服务商,提供心脏预防评估中心解决方案,居家康复解决方案等多类型心肺相关方案,助力医疗机构在学科建设,科室运营,品牌推广,专家带教等方面实现全面发展,欢迎了解!'}
                    ]
                },
                component: () => import('@/views/Solution/index.vue'),
            },
            {
                path: '/fileCenter',
                name: 'FileCenter',
                meta: {
                    title: '文件中心',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/FileCenter/index.vue'),
            },
            {
                path: '/cardiacRehabilitation',
                name: 'CardiacRehabilitation',
                meta: {
                    title: '心脏康复',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/cardiacRehabilitation/index.vue'),
            },
            {
                path: '/heartSafety',
                name: 'HeartSafety',
                meta: {
                    title: '心脏安全',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/HeartSafety/index.vue'),
            },
            {
                path: '/heartPrevention',
                name: 'HeartPrevention',
                meta: {
                    title: '心脏预防',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/HeartPrevention/index.vue'),
            },
            {
                path: '/integrationSpAMe',
                name: 'IntegrationSpAMe',
                meta: {
                    title: '体医融合',
                    metas:[
                        {name:'keywords',content:''},
                        {name:'description',content:''}
                    ]
                },
                component: () => import('@/views/IntegrationSpAMe/index.vue'),
            },
        ],
    },
]
